import { AxiosError } from "axios";
import { api, apiFile } from "../../api/api";
import Usuario from "../../model/administracao/cadastro/Usuario";
import Setor from "model/administracao/cadastro/Setor";
import SetorPlanoAuditoria from "model/auditoria5s/planoDeAuditoria/SetorPlanoAuditoria";
import Auditoria from "model/auditoria5s/auditoria/Auditoria";


class AuditoriaAppService {

    getUsuariosSetor(idSetor: number) {

        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/auditoria/app/setor/usuarios?setor=${idSetor}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    geraParaOutrosSetores() {
        return new Promise<Boolean>((resolve, reject): void => {
            api.get("/auditoria/app/geraParaOutrosSetores")
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    setores() {
        return new Promise<Setor[]>((resolve, reject): void => {
            api
                .get(`/auditoria/app/setores`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    planosUsuarioLogado() {
        return new Promise<SetorPlanoAuditoria[]>((resolve, reject): void => {
            api
                .get(`/auditoria/app/setorPlanos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    gerarAuditoria(idPlano: number) {
        return new Promise<Auditoria>((resolve, reject): void => {
            api
                .post(`/auditoria/app/gerarAuditoria/${idPlano}`, "{}")
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default AuditoriaAppService;
